export default {
  // Common
  common: {
    welcome: 'Welcome',
    logout: 'Log out',
    users: 'Users',
    order: 'Order',
    orders: 'Orders',
    orderCount: '{{count}} order(s)',
    comingSoon: 'This page is coming soon',
    shipments: 'Shipments',
    fleet: 'Fleet',
    languageUpdateError: 'Error updating language',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    search: 'Search',
    filter: 'Filter',
    reset: 'Reset',
    resetFilters: 'Reset filters',
    back: 'Back',
    next: 'Next',
    contents: 'Contents',
    previous: 'Previous',
    submit: 'Submit',
    confirm: 'Confirm',
    close: 'Close',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    yes: 'Yes',
    no: 'No',
    optional: 'Optional',
    required: 'Required',
    dashboard: 'Dashboard',
    settings: 'Settings',
    view: 'View',
    download: 'Download',
    actions: 'Actions',
    details: 'Details',
    noData: 'No data available',
    weight: 'Weight',
    weightUnit: 'kg',
    pallets: 'Pallets',
    price: 'Price',
    priceUnit: '€',
    contact: 'Contact',
    phone: 'Phone',
    email: 'Email',
    address: 'Address',
    publish: 'Publish',
    follow: 'Follow',
    accept: 'Accept',
    decline: 'Decline',
    accepting: 'Accepting...',
    declining: 'Declining...',
    confirming: 'Confirming...',
    all: 'All',
    active: 'Active',
    pending: 'Pending',
    completed: 'Completed',
    pickup: 'Pickup',
    delivery: 'Delivery',
    route: 'Route',
    date: 'Date',
    time: 'Time',
    status: 'Status',
    cargo: 'Cargo',
    trailer: 'Trailer',
    driver: 'Driver',
    vehicle: 'Vehicle',
    company: 'Company',
    name: 'Name',
    firstName: 'First name',
    lastName: 'Last name',
    description: 'Description',
    instructions: 'Instructions',
    notes: 'Notes',
    message: 'Message',
    amount: 'Amount',
    shipper: 'Shipper',
    transporter: 'Transporter',
    admin: 'Administrator',
  },

  // Auth
  auth: {
    welcomeTitle: 'Welcome to Velox',
    login: {
      title: 'Login',
      subtitle: 'Log in or create an account to access your TMS platform',
      email: 'Email',
      password: 'Password',
      forgotPassword: 'Forgot password?',
      submit: 'Sign in',
      loading: 'Signing in...',
      success: 'Successfully logged in!',
      error: 'Incorrect credentials',
      fillAllFields: 'Please fill in all fields',
    },
    signup: {
      title: 'Sign up',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm password',
      firstName: 'First name',
      lastName: 'Last name',
      phone: 'Phone',
      companyName: 'Company name',
      companyType: 'Type',
      shipper: 'Shipper',
      transporter: 'Carrier',
      registrationNumber: 'Fiscal ID',
      registrationNumberPlaceholder: 'e.g., SIRET, VAT, Tax ID...',
      registrationNumberVerifying: 'Verifying...',
      registrationNumberValid: '✓ Valid number',
      registrationNumberInvalid: '✗ Invalid number',
      registrationNumberExists: '⚠️ This company is already registered',
      countryCode: 'Country',
      countryCodePlaceholder: 'FR',
      verified: 'Verified',
      alreadyExists: 'Already registered',
      verifying: 'Verifying...',
      iban: 'IBAN',
      ibanPlaceholder: 'GB82 WEST 1234 5698 7654 32',
      ibanRequired: 'IBAN is required',
      foundedDate: 'Company founding date',
      foundedDateRequired: 'Company founding date is required',
      acceptTerms: 'I accept the Terms and Conditions and Privacy Policy',
      acceptTermsPart1: 'I accept the',
      termsLink: 'Terms and Conditions',
      acceptTermsPart2: 'and the',
      privacyLink: 'Privacy Policy',
      termsRequired: 'You must accept the Terms and Conditions',
      submit: 'Create account',
      loading: 'Creating...',
      success: 'Account created successfully!',
      error: 'Error creating account',
      fillRequired: 'Please fill in all required fields',
      passwordMismatch: 'Passwords do not match',
      passwordLength: 'Password must be at least 6 characters long',
    },
    resetPassword: {
      title: 'Reset password',
      subtitle: 'Enter your email address to receive a reset link',
      email: 'Email',
      submit: 'Send link',
      loading: 'Sending...',
      success: 'Reset email sent!',
      error: 'Error sending email',
      backToLogin: 'Back to login',
      enterEmail: 'Please enter your email address',
    },
    newPassword: {
      title: 'New password',
      subtitle: 'Choose a new secure password for your account',
      password: 'New password',
      confirmPassword: 'Confirm password',
      placeholder: '••••••••',
      submit: 'Update password',
      loading: 'Updating...',
      success: 'Password updated successfully',
      error: 'Error updating password',
      mismatch: 'Passwords do not match',
      tooShort: 'Password must be at least 8 characters long',
      invalidToken: 'This reset link is invalid or has expired. Please request a new one.',
      invalidTokenTitle: 'Invalid link',
      backToLogin: 'Back to login',
    },
  },

  // Dashboard
  dashboard: {
    header: {
      shipper: 'Shipper Dashboard',
      transporter: 'Carrier Dashboard',
      driver: 'My Missions',
      admin: 'Admin Panel',
    },
    stats: {
      totalOrders: 'Total orders',
      activeOrders: 'Active orders',
      activeOrdersLabel: 'In progress',
      draftOrders: 'Drafts',
      deliveredOrders: 'Delivered',
      pendingBids: 'Pending offers',
      completedOrders: 'Completed orders',
      totalRevenue: 'Total revenue',
      activeDrivers: 'Active drivers',
      availableDrivers: 'Available drivers',
      availableVehicles: 'Available vehicles',
      ongoingMissions: 'Ongoing missions',
      activeMissions: 'Active missions',
      completedMissions: 'Completed missions',
      assignedMissions: 'Assigned',
      totalTransporters: 'Total carriers',
      totalDrivers: 'Total drivers',
      totalCommands: 'Total orders',
      unpaidPayments: 'Pending payments',
    },
    emptyState: {
      noOrders: 'No orders yet',
      noOrdersInProgress: 'No orders in progress',
      noActiveMissions: 'No active missions',
      noMissions: 'No missions yet',
      noAssignedMissions: 'No assigned missions',
      noCompletedMissions: 'No completed missions',
      noBids: 'No offers yet',
      noInProgress: 'No orders in progress',
      viewAllOrders: 'View all my orders',
    },
    pendingReservations: {
      title: 'Pending reservations',
      subtitle: '{{count}} carrier(s) have booked your orders',
      subtitles: ' has',
      subtitlep: ' have',
    },
    ordersInProgress: {
      title: 'Orders in progress',
      subtitle: 'Your assigned and ongoing orders',
    },
    activeMissions: {
      title: 'Active missions',
      noMissions: 'No active missions',
      consultMarketplace: 'Check the marketplace to book missions',
    },
    createOrder: 'Create order',
  },

  // Orders
  orders: {
    title: 'My Orders',
    noCoordinates: 'Missing coordinates',
    print: {
      title: 'Order Form',
      button: 'Download',
      printButton: 'Print',
      generating: 'Generating...',
      printing: 'Printing...',
      success: 'Image generated',
      downloaded: 'Order form successfully downloaded',
      error: 'Error',
      elementNotFound: 'Unable to find content to capture',
      generationFailed: 'Failed to generate image',
      qrNotGenerated: 'QR Code not generated',
      pickupInfo: '📦 Pickup Information',
      deliveryInfo: '🚚 Delivery Information',
      cargoInfo: '📋 Cargo',
      additionalInstructions: '⚠️ Additional Instructions',
      notSpecified: 'Not specified',
      title_field: 'Title:',
      vehicleType: 'Vehicle type:',
      volume: 'Volume:',
      platformDescription: 'VELOX - Logistics Management Platform',
      generatedOn: 'Document generated on',
    },
    subtitle: 'Manage all your orders by status',
    create: 'Create order',
    createNew: '+ Create order',
    filterByStatus: 'Filter by status',
    filterDescription: 'Select a status to view matching orders',
    selectStatus: 'Select status',
    orderNumber: 'Order number',
    statuses: {
      all: 'All',
      draft: 'Draft',
      posted: 'Posted',
      booked: 'Booked',
      assigned: 'Assigned',
      in_transit: 'In transit',
      delivered: 'Delivered',
      cancelled: 'Cancelled',
      drafts: 'Drafts',
      posted_plural: 'Posted',
      booked_plural: 'Booked',
      assigned_plural: 'Assigned',
      in_transit_plural: 'In transit',
      delivered_plural: 'Delivered',
      cancelled_plural: 'Cancelled',
    },
    statusDescriptions: {
      draft: 'Order being created',
      posted: 'Order published on marketplace',
      booked: 'Request accepted, awaiting driver/vehicle assignment',
      assigned: 'Driver and vehicle assigned',
      in_transit: 'Order in transit',
      delivered: 'Order delivered successfully',
      cancelled: 'Order cancelled',
    },
    status: {
      draft: 'Draft',
      posted: 'Posted',
      booked: 'Booked',
      assigned: 'Assigned',
      inTransit: 'In transit',
      delivered: 'Delivered',
      cancelled: 'Cancelled',
    },
    statusLabels: {
      pending: 'Pending confirmation',
      accepted: 'Accepted',
      assigned: 'Assigned',
    },
    emptyStates: {
      all: 'No orders yet',
      draft: 'No drafts',
      posted: 'No posted orders',
      booked: 'No booked orders',
      assigned: 'No assigned orders',
      in_transit: 'No orders in transit',
      delivered: 'No delivered orders',
      cancelled: 'No cancelled orders',
    },
    priceValidated: 'Price confirmed',
    priceProposed: 'Proposed price',
    myOffers: 'My offers',
    reservationPending: 'Pending reservation',
    confirmation: 'Confirmation',
    refusal: 'Decline',
    yourPreviousOfferDeclined: 'Your previous offer was declined',
    declinedOn: 'Declined on',
    yourPendingOffer: 'Your pending offer',
    proposedAmount: 'Proposed amount',
    submittedOn: 'Submitted on',
    bookFixedPrice: 'Book at fixed price',
    makeOffer: 'Make an offer',
    makeNewOffer: 'Make a new offer',
    offerPendingResponse: 'Offer pending response',
    cancel: 'Cancel',
    confirmCancel: 'Do you really want to cancel mission {{orderNumber}}?',
    cancelSuccess: 'Mission successfully cancelled',
    cancelError: 'Error cancelling mission',
    transporter: 'Carrier',
    statusLabel: 'Status',
    pickupDate: 'Pickup date',
    pickupLocation: 'Pickup location',
    deliveryDate: 'Delivery date',
    deliveryLocation: 'Delivery location',
    weight: 'Weight',
    price: 'Price',
    trailerType: 'Trailer type',
    form: {
      title: 'Create order',
      subtitle: 'Fill in your transport details',
      priceRequired: 'Proposed price required to publish order',
    },
    card: {
      order: 'Order',
      validatedPrice: 'Confirmed price',
      proposedPrice: 'Proposed price',
      weight: 'Weight',
      pallets: 'pallets',
      boxes: 'boxes',
      euroPallets: 'euro-pallets',
      publish: 'Publish',
      myOffers: 'My offers',
      track: 'Track',
      details: 'Details',
    },
    details: {
      title: 'Full order details',
      proposedPrice: 'Proposed price',
      cargo: 'Cargo',
      cargoTitle: 'Title:',
      cargoDescription: 'Description:',
      cargoImage: 'Cargo photo',
      startImages: 'Pickup photos',
      deliveryImages: 'Delivery photos',
      weight: 'Weight:',
      pallets: 'Pallets:',
      boxes: 'Boxes:',
      euroPallets: 'Euro-pallets:',
      volume: 'Volume:',
      type: 'Type:',
      route: 'Route',
      pickup: 'Pickup:',
      delivery: 'Delivery:',
      transporterInfo: 'Carrier information',
      company: 'Company',
      assignedDriver: 'Assigned driver',
      vehicle: 'Vehicle',
      plateNumber: 'Plate',
      licenseNumber: 'License',
      trailerType: 'Trailer type',
      specialInstructions: 'Special instructions',
      visibleMarketplace: '✓ Visible on marketplace',
      edit: 'Edit',
      print: 'Print',
      delete: 'Delete',
      close: 'Close',
      confirmDelete: 'Confirm deletion',
      confirmDeleteText:
        'Are you sure you want to delete order {{orderNumber}}? This action cannot be undone.',
      cancel: 'Cancel',
      deleteSuccess: 'Order deleted successfully',
      deleteError: 'Error deleting order',
    },
    messages: {
      publishedSuccess: 'Order published successfully!',
      publishError: 'Error publishing order',
    },
  },

  // Bids
  bids: {
    title: 'Offers',
    offersReceived: 'Offers received',
    offersReceivedCount: 'Offers received ({{count}})',
    viewBids: 'View offers',
    noBids: 'No offers yet',
    noBidsReceived: 'No offers received yet',
    newBid: 'New offer',
    amount: 'Amount',
    proposedAmount: 'Proposed amount',
    message: 'Message',
    submit: 'Submit offer',
    accept: 'Accept',
    decline: 'Decline',
    accepted: 'Accepted',
    declined: 'Declined',
    pending: 'Pending',
    receivedOn: 'Received on',
    orderDetails: 'Order details',
    acceptBid: 'Accept',
    declineBid: 'Decline',
  },

  // Marketplace
  marketplace: {
    title: 'Marketplace',
    subtitle: 'Find available orders',
    filters: 'Filters',
    trailerType: 'Trailer type',
    allTypes: 'All types',
    departureCity: 'Departure city',
    departureCityPlaceholder: 'e.g. London',
    arrivalCity: 'Arrival city',
    arrivalCityPlaceholder: 'e.g. Manchester',
    availabilityDate: 'Availability date',
    selectDate: 'Select a date',
    sortByDistance: 'Sort by distance',
    noSort: 'No sorting',
    sortAsc: 'Closest first',
    sortDesc: 'Farthest first',
    resetFilters: 'Reset filters',
    searchOrders: 'Search orders...',
    sortBy: 'Sort by',
    sortNewest: 'Newest',
    sortPrice: 'Price',
    sortDistance: 'Distance',
    noOrders: 'No available orders',
    loadMore: 'Load more',
    pickupLocation: 'Pickup location',
    deliveryLocation: 'Delivery location',
    weight: 'Weight',
    vehicleType: 'Vehicle type',
    price: 'Price',
    messages: {
      applicationSent: 'Your application has been sent successfully',
    },
    errors: {
      applicationError: 'Error sending application',
    },
    card: {
      pickup: 'Pickup',
      delivery: 'Delivery',
      weight: 'Weight:',
      pallets: 'Pallets:',
      declinedBid: 'Your previous offer was declined',
      declinedAmount: 'Amount:',
      declinedOn: 'Declined on',
      pendingBid: 'Your pending offer',
      proposedAmount: 'Proposed amount',
      message: 'Message',
      submittedOn: 'Submitted on',
      bookFixed: 'Book at fixed price',
      bidPending: 'Offer pending response',
      makeNewBid: 'Make a new offer',
      makeBid: 'Make an offer',
      applying: 'Sending...',
      applyForOrder: 'Apply for this order',
    },
    placeBid: 'Make an offer',
    viewDetails: 'View details',
    bookOrder: 'Book order',
    bookingSuccess: 'Mission booked successfully',
    bookingError: 'Error booking mission',
  },

  // Fleet
  fleet: {
    title: 'Fleet Management',
    subtitle: 'Manage your vehicles and drivers',
    vehicles: 'Vehicles',
    drivers: 'Drivers',
    wizard: {
      step1: 'Step 1: Vehicle Type',
      step2: 'Step 2: Registration Card Photos',
      step3: 'Step 3: Vehicle Information',
      step1Description: 'Select the vehicle type',
      step2Description: 'Upload photos (optional)',
      step3Description: 'Complete the information',
    },
    extraction: {
      analyzing: 'Analyzing...',
      analyzingFront: 'Analyzing front side...',
      analyzingBack: 'Analyzing back side...',
      success: 'Data extracted successfully',
      frontComplete: 'Front analyzed',
      backComplete: 'Back analyzed',
      successDesc: 'Vehicle information has been automatically filled',
      error: 'Extraction error',
      errorDesc: 'Unable to extract data. Please fill in manually.',
      step1: 'Step 1/2: Front',
      step2: 'Step 2/2: Back',
      optional: 'Optional photos:',
      optionalDesc: 'You can take photos of the registration card to auto-fill the fields, or enter the information manually.',
      notRegistrationCard: 'Document not recognized',
      notRegistrationCardDesc: 'This image does not appear to be a registration card. Please take a clear photo of a valid registration card.',
    },
    dialogs: {
      addVehicle: 'Add vehicle',
      editVehicle: 'Edit vehicle',
      captureRegistration: 'Capture Registration Card',
      captureRegistrationFront: 'Registration Card - Front',
      captureRegistrationBack: 'Registration Card - Back',
      inviteDriver: 'Invite driver',
      editDriver: 'Edit driver',
      vehicleType: 'Vehicle type',
      plateNumber: 'License plate',
      plateNumberPlaceholder: 'e.g. AB-123-CD',
      vin: 'VIN number',
      vinPlaceholder: 'e.g. 1HGBH41JXMN109186',
      brand: 'Brand',
      brandPlaceholder: 'e.g. Mercedes-Benz',
      model: 'Model',
      modelPlaceholder: 'e.g. Sprinter',
      year: 'Year',
      yearPlaceholder: 'e.g. 2020',
      lastMaintenance: 'Last maintenance',
      lastMaintenancePlaceholder: 'Select a date',
      nextMaintenance: 'Next maintenance',
      nextMaintenancePlaceholder: 'Select a date',
      status: 'Status',
      email: 'Email',
      firstName: 'First name',
      lastName: 'Last name',
      phone: 'Phone',
      licenseNumber: 'License number',
      licenseExpiry: 'License expiry date',
      select: 'Select',
      selectType: 'Select type',
      selectVehicleType: 'Select a type',
      required: '*',
      cancel: 'Cancel',
      add: 'Add',
      addingVehicle: 'Adding vehicle...',
      save: 'Save',
      sendInvitation: 'Send invitation',
      statusAvailable: 'Available',
      statusOnMission: 'On mission',
      statusOffDuty: 'Off duty',
    },
    invitations: 'Invitations',
    myVehicles: 'My vehicles',
    myDrivers: 'My drivers',
    addVehicle: 'Add vehicle',
    addDriver: '+ Invite driver',
    inviteDriver: 'Invite driver',
    addFirstVehicle: 'Add your first vehicle',
    inviteFirstDriver: 'Invite your first driver',
    noVehicles: 'No vehicles registered',
    noDrivers: 'No drivers registered',
    noInvitations: 'No invitations',
    pendingInvitations: 'Pending invitations',
    activeDrivers: 'Active drivers',
    vehicleDetails: {
      brand: 'Brand',
      model: 'Model',
      year: 'Year',
      plateNumber: 'Plate',
      type: 'Type',
      status: 'Status',
      available: 'Available',
      unavailable: 'Unavailable',
      inUse: 'In use',
      onMission: 'On mission',
      maintenance: 'Maintenance',
      lastMaintenance: 'Last maintenance',
      nextMaintenance: 'Next maintenance',
      vin: 'VIN:',
      modelLabel: 'Model:',
      nextMaintenanceLabel: 'Next maintenance:',
    },
    driverDetails: {
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      license: 'License',
      licenseNumber: 'License number',
      licenseExpiry: 'License expiry',
      status: 'Status',
      available: 'Available',
      onMission: 'On mission',
      offDuty: 'Off duty',
      unavailable: 'Unavailable',
      noName: 'Unnamed driver',
      licenseExpiresOn: 'License expires on',
      position: 'Position',
      positionUnavailable: 'Position unavailable',
      addedOn: 'Added on',
    },
    invitationDetails: {
      email: 'Email',
      phone: 'Phone',
      pending: 'Pending',
      expired: 'Expired',
      expires: 'Expires',
      sentOn: 'Invitation sent on',
    },
    cancelInvitation: 'Cancel invitation',
    cancelInvitationTitle: 'Cancel invitation',
    cancelInvitationDescription: 'Are you sure you want to cancel the invitation for {{name}} ({{email}})? This action cannot be undone.',
    confirmCancel: 'Yes, cancel',
    invitationDeleted: 'Invitation cancelled',
    invitationDeletedDescription: 'The invitation has been successfully deleted',
    invitationDeleteError: 'Unable to delete invitation',
    resendEmail: 'Resend email',
    emailResent: 'Email resent',
    emailResentDescription: 'The invitation email has been resent to {{email}}',
    actions: {
      edit: 'Edit',
      delete: 'Delete',
      cancel: 'Cancel',
    },
    deleteDialog: {
      vehicleTitle: 'Delete vehicle',
      vehicleDescription: 'Are you sure you want to delete vehicle',
      driverTitle: 'Delete driver',
      driverDescription: 'Are you sure you want to delete',
      irreversible: 'This action cannot be undone.',
    },
    documentStatus: {
      verified: 'Verified',
      unverified: 'Not verified',
      expired: 'Expired',
      expiringSoon: 'Expiring soon',
      registrationCard: 'Registration card',
      driverLicense: 'Driver license',
      scanRegistration: 'Scan registration card',
      scanLicense: 'Scan driver license',
      rescan: 'Re-scan',
      lockedField: 'Locked (OCR verified)',
    },
    license: {
      title: 'License verification',
      howTo: 'How to:',
      howToDesc: 'Take a photo of the front and back of the license. The data will be extracted and locked automatically.',
      front: 'License front',
      back: 'License back',
      captureFront: 'Capture front',
      captureBack: 'Capture back',
      frontDone: 'Front analyzed',
      backDone: 'Back analyzed',
      extracted: 'Data extracted',
      extractedData: 'License data',
      lockedNotice: 'These fields will be locked and cannot be edited manually.',
      categories: 'Categories',
      save: 'Save license',
      saved: 'License saved',
      savedDesc: 'The license has been verified and saved.',
      incomplete: 'Incomplete data',
      incompleteDesc: 'License number and expiry date are required.',
      notALicense: 'Document not recognized',
      notALicenseDesc: 'This image does not appear to be a driver license. Please take a clear photo of a valid license.',
    },
  },

  // Missions
  missions: {
    title: 'My Missions',
    myMissions: 'My Missions',
    subtitle: 'Manage your transport missions',
    all: 'All',
    pending: 'Pending',
    upcoming: 'Upcoming',
    ongoing: 'Ongoing',
    active: 'Active',
    completed: 'Completed',
    assigned: 'Assigned',
    search: 'Search by number, city or address...',
    noResults: 'No missions match your search',
    resultFound: 'result found',
    resultsFound: 'results found',
    noMissions: 'No missions',
    noMissionPending: 'No pending missions',
    noMissionActive: 'No active missions',
    noMissionCompleted: 'No completed missions',
    filters: {
      title: 'Filters',
      trailerType: 'Trailer type',
      distance: 'Distance',
      allTrailers: 'All types',
      allDistances: 'All distances',
      distance0to100: 'Less than 100 km',
      distance100to500: '100 - 500 km',
      distance500to1000: '500 - 1000 km',
      distance1000plus: 'More than 1000 km',
      clearFilters: 'Clear filters',
    },
    assignDriver: 'Assign driver',
    assignVehicle: 'Assign vehicle',
    startMission: 'Start mission',
    completeMission: 'Complete mission',
    orderNumber: 'Order number',
    pickup: 'Pickup',
    delivery: 'Delivery',
    status: 'Status',
    accept: 'Accept',
    decline: 'Decline',
    scanQR: 'Scan QR',
    openDocuments: 'Documents',
    uploadPOD: 'Upload POD',
    reportDelay: 'Report delay',
    actions: {
      assign: 'Assign',
      viewDetails: 'View details',
      accept: 'Accept',
      decline: 'Decline',
      refuse: 'Refuse',
      scanQR: 'Scan QR',
      documents: 'Documents',
      viewDocuments: 'View documents',
      reportDelay: 'Report delay',
      route: 'Route',
    },
    history: 'History',
    inProgress: 'In progress',
    card: {
      orderNumber: 'Order No.',
      from: 'From',
      to: 'To',
      order: 'Order',
      weight: 'Weight',
      type: 'Type',
      price: 'Price',
      driver: 'Driver:',
      vehicle: 'Vehicle:',
      assign: 'Assign',
      pickup: 'Pickup',
      delivery: 'Delivery',
      cargo: 'Cargo',
      notAssigned: 'Not assigned',
      assignDriver: 'Assign driver',
      delayReported: 'Delay reported',
      status: {
        completed: 'Completed',
        inProgress: 'In progress',
        assigned: 'Assigned',
        pending: 'Pending',
      },
    },
    empty: {
      assigned: 'No assigned missions',
      active: 'No active missions',
      completed: 'No completed missions',
    },
  },

  // Billing
  // Billing
  billing: {
    title: 'Billing',
    detailsTitle: 'Details',
    subtitle: 'Manage your purchase orders and invoices',
    filterByStatus: 'Filter by status',
    allStatuses: 'All statuses',
    documentType: 'Document type',
    documentNumber: 'Number',
    amount: 'Amount excl. VAT',
    vatRate: 'VAT rate',
    vatAmount: 'VAT amount',
    totalAmount: 'Total incl. VAT',
    issueDate: 'Issue date',
    dueDate: 'Due date',
    paidDate: 'Payment date',
    types: {
      order_form: 'Purchase order',
      invoice: 'Invoice',
    },
    stats: {
      title: 'Overview',
      totalInvoiced: 'Total invoiced',
      totalPaid: 'Total paid',
      totalPending: 'Pending',
      paymentProgress: 'Payment progress',
    },
    statuses: {
      draft: 'Draft',
      sent: 'Sent',
      paid: 'Paid',
      cancelled: 'Cancelled',
    },
    tabs: {
      orderForms: 'Purchase Orders',
      invoices: 'Invoices',
    },
    emptyStates: {
      orderForms: {
        title: 'No purchase orders',
        description: 'Purchase orders will appear here once generated.',
      },
      invoices: {
        title: 'No invoices',
        description: 'Invoices will appear here once generated.',
      },
    },
    messages: {
      pdfSuccess: 'PDF downloaded successfully',
      pdfError: 'Error generating PDF',
      markedAsPaid: 'Document marked as paid',
      titleRequired: 'Title cannot be empty',
      titleUpdated: 'Title updated successfully',
    },
    status: {
      paid: 'Paid',
      sent: 'Sent',
      cancelled: 'Cancelled',
      draft: 'Draft',
    },
    documentTypes: {
      orderForm: 'Purchase Order',
      invoice: 'Invoice',
    },
    card: {
      order: 'Order:',
      route: 'Route:',
      amountHT: 'Amount (excl. VAT)',
      vat: 'VAT',
      totalTTC: 'Total (incl. VAT)',
      issuedOn: 'Issued on:',
      dueDate: 'Due date:',
      paidOn: 'Paid on:',
      view: 'View',
      pdf: 'PDF',
    },
    dialog: {
      documentNumber: 'Document number',
      customTitle: 'Custom Title',
      noTitle: 'No title',
      titlePlaceholder: 'Enter a title for this document',
      shipper: 'Shipper',
      transporter: 'Carrier',
      orderDetails: 'Order details',
      orderNumber: 'Order number:',
      cargo: 'Cargo:',
      route: 'Route:',
      financialDetails: 'Financial details',
      amountHT: 'Amount (excl. VAT)',
      vat: 'VAT',
      totalTTC: 'Total (incl. VAT)',
      importantDates: 'Important dates',
      issueDate: 'Issue date',
      dueDate: 'Due date',
      paymentDate: 'Payment date',
      notes: 'Notes',
      markAsPaid: 'Mark as paid',
      downloadPDF: 'Download PDF',
    },
    orderForms: 'Purchase Orders',
    invoices: 'Invoices',
    noDocuments: 'No documents',
    date: 'Date',
    paid: 'Paid',
    unpaid: 'Unpaid',
    overdue: 'Overdue',
    markAsPaid: 'Mark as paid',
    viewDocument: 'View document',
    downloadPDF: 'Download PDF',
    details: {
      shipper: 'Shipper',
      transporter: 'Carrier',
      orderDetails: 'Order details',
      route: 'Route',
      cargo: 'Cargo',
      financial: 'Financial summary',
      subtotal: 'Subtotal',
      vat: 'VAT',
      total: 'Total (incl. VAT)',
      createdAt: 'Created on',
      dueDate: 'Due date',
      paidAt: 'Paid on',
    },
  },

  // Notifications
  notifications: {
    title: 'Notifications',
    markAllRead: 'Mark all as read',
    markAll: 'Mark all',
    noNotifications: 'No notifications',
    empty: 'No notifications',
    markAsReadError: 'Error marking notification as read',
    markAllAsReadError: 'Error marking all notifications as read',
    allMarkedAsRead: 'All notifications marked as read',
    notificationNotFound: 'Unable to find this order',
    types: {
      mission_assigned: 'Mission assigned',
      new_bid: 'New offer',
      bid_accepted: 'Offer accepted',
      bid_declined: 'Offer declined',
      order_updated: 'Order updated',
      mission_started: 'Mission started',
      mission_completed: 'Mission completed',
      payment_received: 'Payment received',
      rating_reminder: 'Rating reminder',
    },
  },

  // Navigation
  nav: {
    dashboard: 'Dashboard',
    marketplace: 'Marketplace',
    missions: 'Missions',
    liveMap: 'Live Map',
    myMissions: 'My Missions',
    myOrders: 'My Orders',
    fleet: 'Fleet',
    billing: 'Billing',
    settings: 'Settings',
    logout: 'Log out',
  },

  // Tracking
  liveMap: {
    description: 'Track all your active missions in real-time',
    noActiveMissions: 'No active missions at the moment',
    filters: 'Filters',
    searchPlaceholder: 'Search by order number...',
    noResults: 'No missions match the filters',
    dateFilter: 'Period',
    allOrders: 'All orders',
    today: 'Today',
    last7Days: 'Last 7 days',
    last30Days: 'Last 30 days',
    last90Days: 'Last 90 days',
    last365Days: 'Last 365 days',
  },

  tracking: {
    title: 'Order Tracking',
    orderNotFound: 'Order not found',
    returnToDashboard: 'Return to dashboard',
    deliveryDocuments: 'Delivery documents',
    trackingHistory: 'Tracking history',
    trackingMap: 'Tracking map',
    noEvents: 'No tracking events yet',
    interactiveMap: 'Interactive map',
    noCoordinates: 'GPS coordinates not available for this order',
    events: {
      pickup_confirmed: 'Pickup confirmed',
      in_transit: 'In transit',
      delivered: 'Delivered',
      exception: 'Exception',
    },
  },

  // Settings
  settings: {
    companyDocuments: {
      title: 'Documents added by Velox',
      description: 'Documents attached to your company by the Velox team.',
      empty: 'No document has been added yet.',
    },
    title: 'Settings',
    subtitle: 'Manage your personal and account information',
    tabs: {
      profile: 'Profile',
      company: 'Company',
      language: 'Language',
      email: 'Email',
      password: 'Password',
      notifications: 'Notifications',
    },
    profile: {
      title: 'Personal Information',
      description: 'Update your personal details',
      firstName: 'First Name',
      lastName: 'Last Name',
      phone: 'Phone',
      save: 'Save Changes',
      companyLogo: 'Company Logo',
      profilePhoto: 'Profile Photo',
      changeImage: 'Change Image',
      imageHint: 'JPG, PNG or WebP. Max 2 MB.',
      imageUploadSuccess: 'Image updated successfully',
      imageUploadError: 'Error uploading image',
      imageTypeError: 'Unsupported format. Use JPG, PNG or WebP.',
      imageSizeError: 'File is too large. Maximum 2 MB.',
    },
    company: {
      title: 'Company Information',
      description: 'Manage your company details',
      name: 'Company Name',
      registrationNumber: 'Company Registration Number',
      registrationNumberDescription: 'SIRET, VAT number, or other tax ID depending on your country',
      iban: 'IBAN (optional)',
      ibanPlaceholder: 'BE71 0961 2345 6769',
      ibanDescription: 'Used for payments and invoicing. You can add it later.',
      ibanInvalid: 'Invalid IBAN',
      address: 'Address',
      phone: 'Phone',
      save: 'Save Changes',
    },
    language: {
      title: 'Interface Language',
      description: 'Choose your preferred language',
      label: 'Language',
      note: 'The language will be applied to the entire interface',
    },
    email: {
      title: 'Email Address',
      description: 'Update your login email address',
      newEmail: 'New Email Address',
      update: 'Update Email',
      notifications: {
        label: 'Email notifications',
        description: 'Receive important notifications by email',
      },
    },
    password: {
      title: 'Password',
      description: 'Change your login password',
      currentPassword: 'Current Password',
      newPassword: 'New Password',
      confirmPassword: 'Confirm Password',
      save: 'Change Password',
    },
    notifications: {
      title: 'Notifications',
      description: 'Manage your notification preferences',
      emailLabel: 'Email Notifications',
      emailDescription: 'Receive notifications by email',
    },
    validation: {
      firstNameRequired: 'First name is required',
      lastNameRequired: 'Last name is required',
      companyNameRequired: 'Company name is required',
      maxLength: 'Maximum {{max}} characters',
      emailInvalid: 'Invalid email',
      passwordMin: 'Minimum 6 characters',
      passwordMismatch: 'Passwords do not match',
    },
    messages: {
      profileUpdated: 'Profile updated successfully',
      profileError: 'Error updating profile',
      companyUpdated: 'Company updated successfully',
      companyError: 'Error updating company',
      emailSent: 'Confirmation email sent',
      emailError: 'Error updating email',
      currentPasswordIncorrect: 'Current password is incorrect',
      passwordUpdated: 'Password updated successfully',
      passwordError: 'Error updating password',
      languageUpdated: 'Language updated successfully',
      languageError: 'Error updating language',
      emailPreferencesUpdated: 'Notification preferences updated',
      notificationsUpdated: 'Notification preferences updated',
      notificationsError: 'Error updating notifications',
    },
  },

  // Vehicle Types (Trailer Types)
  vehicleTypes: {
    van: 'Van',
    flatbed: 'Flatbed',
    refrigerated: 'Refrigerated',
    tanker: 'Tanker',
    curtainsider: 'Curtainsider',
    lowloader: 'Lowloader',
    container: 'Container',
    any: 'Any type',
    car: 'Car carrier',
    van_small: 'Small van',
    utility: 'Utility',
    other: 'Other',
  },

  // Admin
  admin: {
    title: 'Admin Panel',
    unpaidPayments: 'Pending payments',
    auditLogs: 'Audit Logs',
    allPaid: 'All payments are up to date',
    noPendingOrders: 'No pending payments',
    transporter: 'Carrier',
    orders: 'Orders',
    totalAmount: 'Total amount',
    action: 'Action',
    markPaid: 'Mark as paid',
    confirmPayment: 'Confirm payment',
    confirmPaymentText:
      'Are you sure you want to mark {{count}} order(s) from {{name}} as paid for a total amount of {{amount}} €?',
    recording: 'Recording...',
    cancel: 'Cancel',
    filters: 'Filters',
    reset: 'Reset',
    table: 'Table',
    allTables: 'All tables',
    allActions: 'All actions',
    dateFrom: 'Start date',
    dateTo: 'End date',
    noAuditLogs: 'No audit logs found',
    tryModifyFilters: 'Try adjusting your filters',
    logsWillAppear: 'Audit logs will appear here',
    timestamp: 'Timestamp',
    user: 'User',
    details: 'Details',
    system: 'System',
    oldValues: 'Old values',
    newValues: 'New values',
    clickToSee: 'Click to view',
    
    // Navigation
    nav: {
      dashboard: 'Dashboard',
      users: 'Users & Companies',
      orders: 'Orders',
      invoices: 'Invoices',
      stats: 'Statistics',
    },
    
    // Dashboard
    dashboard: {
      title: 'Admin Dashboard',
      subtitle: 'Platform overview',
      filters: {
        day: 'Today',
        week: 'This week',
        month: 'This month',
      },
      revenue: 'Revenue',
      ordersDelivered: 'Orders delivered',
      ordersPosted: 'Orders posted',
      ordersInProgress: 'In progress',
      vsLastPeriod: 'vs. last period',
      vsAverage: 'vs. average',
      revenueChart: 'Revenue evolution',
      ordersChart: 'Orders evolution',
    },
    
    // Users & Companies
    users: {
      title: 'Users & Companies',
      subtitle: 'User and company management',
      name: 'Name',
      email: 'Email',
      company: 'Company',
      role: 'Role',
      status: 'Status',
      registrationDate: 'Registration date',
      actions: 'Actions',
      suspend: 'Suspend',
      delete: 'Delete',
      promoteAdmin: 'Promote admin',
      viewDetails: 'View details',
      filters: {
        role: 'Filter by role',
        status: 'Filter by status',
        company: 'Filter by company',
        date: 'Filter by date',
        allRoles: 'All roles',
        allStatuses: 'All statuses',
        allCompanies: 'All companies',
      },
      statuses: {
        active: 'Active',
        suspended: 'Suspended',
        deleted: 'Deleted',
      },
      showDeleted: 'Show deleted accounts',
      deletedHiddenCount: '{{count}} deleted account(s) hidden',
      userDetails: {
        title: 'User details',
        personalInfo: 'Personal information',
        companyInfo: 'Company information',
        phone: 'Phone',
        language: 'Preferred language',
        emailNotifications: 'Email notifications',
        enabled: 'Enabled',
        disabled: 'Disabled',
      },
      companyDetails: {
        createdAt: 'Created on',
        companyCreatedSince: 'Since {{date}}',
        title: 'Company details',
        type: 'Type',
        siret: 'SIRET',
        address: 'Address',
        users: 'Associated users',
        fleet: 'Fleet',
        drivers: 'Drivers',
        documents: 'Documents',
        vehicleCount: 'Vehicles',
        driverCount: 'Drivers',
        documentStatus: 'Document status',
        valid: 'Valid',
        expired: 'Expired',
        missing: 'Missing',
      },
      confirmSuspend: 'Confirm suspension',
      confirmSuspendMessage: 'Are you sure you want to suspend this user?',
      confirmDelete: 'Permanently delete this account',
      confirmDeleteMessage: 'The account will be anonymised: personal data is erased and access is permanently blocked. Order history is preserved. This action is irreversible.',
      deleteSuccess: 'Account deleted and anonymised',
      deleteError: 'Error deleting the account',
      confirmPromote: 'Confirm promotion',
      confirmPromoteMessage: 'Are you sure you want to promote this user to administrator?',
      userSuspended: 'User suspended',
      userDeleted: 'User deleted',
      userPromoted: 'User promoted to administrator',
      error: 'An error occurred',
    },
    
    // Orders
    adminOrders: {
      title: 'Orders',
      subtitle: 'Order management',
      orderId: 'Order ID',
      shipper: 'Shipper',
      transporter: 'Transporter',
      amount: 'Amount',
      status: 'Status',
      date: 'Date',
      actions: 'Actions',
      viewDetails: 'View details',
      markDelivered: 'Mark delivered',
      cancelOrder: 'Cancel',
      viewInvoice: 'View invoice',
      filters: {
        status: 'Filter by status',
        date: 'Filter by date',
        shipper: 'Filter by shipper',
        transporter: 'Filter by transporter',
        allStatuses: 'All statuses',
      },
      orderDetails: {
        title: 'Order details',
        route: 'Route',
        cargo: 'Cargo',
        pricing: 'Pricing',
        documents: 'Documents',
        tracking: 'Tracking',
      },
      confirmMarkDelivered: 'Confirm delivery',
      confirmMarkDeliveredMessage: 'Are you sure you want to mark this order as delivered?',
      confirmCancel: 'Confirm cancellation',
      confirmCancelMessage: 'Are you sure you want to cancel this order?',
      orderMarkedDelivered: 'Order marked as delivered',
      orderCancelled: 'Order cancelled',
      error: 'An error occurred',
    },
    
    // Invoices
    invoices: {
      title: 'Invoices',
      subtitle: 'Invoice management',
      invoiceId: 'Invoice ID',
      shipper: 'Shipper',
      transporter: 'Transporter',
      amount: 'Amount',
      status: 'Status',
      date: 'Date',
      actions: 'Actions',
      markPaidAction: 'Mark as paid',
      report: 'Report',
      viewDetails: 'View details',
      statuses: {
        pending: 'Pending',
        paid: 'Paid',
        reported: 'Reported',
        cancelled: 'Cancelled',
      },
      invoiceDetails: {
        title: 'Invoice details',
        shipperInfo: 'Shipper information',
        transporterInfo: 'Transporter information',
        orderInfo: 'Order information',
        history: 'History',
        comments: 'Admin comments',
        addComment: 'Add comment',
      },
      confirmMarkPaid: 'Confirm payment',
      confirmMarkPaidMessage: 'Are you sure you want to mark this invoice as paid?',
      confirmReport: 'Report invoice',
      confirmReportMessage: 'Are you sure you want to report this invoice?',
      confirmCancel: 'Cancel invoice',
      confirmCancelMessage: 'Are you sure you want to cancel this invoice? This action is irreversible.',
      reportReason: 'Report reason',
      invoiceMarkedPaid: 'Invoice marked as paid',
      invoiceReported: 'Invoice reported',
      commentAdded: 'Comment added',
      error: 'An error occurred',
    },
  },

  // Shipper
  shipper: {
    dashboard: {
      title: 'Shipper Dashboard',
      createOrder: 'Create order',
      pendingReservations: 'Pending reservations',
      pendingReservationsSubtitle:
        '{{count}} carrier(s) have booked your orders',
      pendingBids: 'Received Bids',
      pendingBidsSubtitle: 'You have {{count}} bid(s) awaiting validation',
      ordersInProgress: 'Orders in progress',
      ordersInProgressSubtitle: 'Your assigned and ongoing orders',
      viewAllOrders: 'View all my orders',
      noOrdersInProgress: 'No ongoing orders yet',
    },
    stats: {
      totalOrders: 'Total orders',
      inProgress: 'In progress',
      delivered: 'Delivered',
      drafts: 'Drafts',
    },
    reservation: {
      pending: 'Pending reservation',
      transporter: 'Carrier',
      confirming: 'Confirming...',
      confirm: 'Confirm',
      declining: 'Declining...',
      decline: 'Decline',
    },
    bids: {
      order: 'Order',
      pickup: 'Pickup',
      delivery: 'Delivery',
      transporter: 'Transporter',
      proposedAmount: 'Proposed Amount',
      message: 'Message',
      submittedOn: 'Submitted on',
    },
    messages: {
      reservationConfirmed: 'Reservation confirmed successfully',
      reservationDeclined: 'Reservation declined',
      bidAccepted: 'Bid accepted successfully',
      bidDeclined: 'Bid declined',
    },
    errors: {
      confirmError: 'Error confirming reservation',
      declineError: 'Error declining reservation',
      acceptBidError: 'Error accepting bid',
      declineBidError: 'Error declining bid',
    },
  },

  // Transporter
  transporter: {
    dashboard: {
      title: 'Carrier Dashboard',
      activeMissions: 'Active missions',
      noActiveMissions: 'No active missions',
      checkMarketplace: 'Visit the marketplace to book missions',
      cancelMissionConfirm:
        'Do you really want to cancel mission {{orderNumber}}?',
    },
    stats: {
      availableVehicles: 'Available vehicles',
      activeMissions: 'Ongoing missions',
      availableDrivers: 'Available drivers',
      completedMissions: 'Completed missions',
    },
    mission: {
      pendingConfirmation: 'Pending confirmation',
      assigned: 'Assigned',
      accepted: 'Accepted',
      pickup: 'Pickup',
      delivery: 'Delivery',
      driver: 'Driver:',
      vehicle: 'Vehicle:',
    },
    messages: {
      missionCanceled: 'Mission cancelled successfully',
    },
  },

  // Landing
  landing: {
    hero: {
      title: 'Velox',
      titleHighlight: 'manage your transport missions,',
      titleEnd: 'effortlessly',
      subtitle:
        'A Progressive Web App optimized for desktop and mobile: publish freight, access the marketplace, assign drivers, validate via QR code, and manage payments — all in one place.',
      tryFree: 'Try for free',
      learnMore: 'Learn more',
      cta: 'Sign up',
    },
    allYouNeed: {
      title: 'Everything you need',
      subtitle:
        'A complete platform to efficiently manage your transport operations',
    },
    features: {
      title: 'Key Features',
      shipments: {
        title: 'Shipment Management',
        description: 'Create, track and manage your transport orders in real-time with an intuitive interface.',
      },
      fleet: {
        title: 'Fleet Management',
        description: 'Optimize the use of your vehicles and drivers with advanced planning tools.',
      },
      tracking: {
        title: 'Real-time Tracking',
        description: 'Locate your deliveries live and keep your customers informed at every step.',
      },
      multiUser: {
        title: 'Multi-user',
        description: 'Collaborate effectively with your team thanks to customized roles and permissions.',
      },
      planning: {
        title: 'Smart Planning',
        description: 'Optimize your routes and plan your missions with intelligent algorithms.',
      },
      security: {
        title: 'Maximum Security',
        description: 'Your data is protected with the highest security standards.',
      },
    },
    workflow: {
      title: 'Main Workflow',
      subtitle: 'V1 - full marketplace and process flow',
      steps: {
        step1: {
          badge: 'Step 1',
          title: 'Freight Publication (Shipper)',
          description: 'Company account creation, order setup (trailer type, destination, delivery window, proposed price). The order appears in the marketplace.',
        },
        step2: {
          badge: 'Step 2',
          title: 'Selection & Booking (Carrier)',
          description: 'Carrier registration and driver onboarding. Marketplace with filters (route, cargo type, distance). Book and confirm freight.',
        },
        step3: {
          badge: 'Step 3',
          title: 'Driver Assignment',
          description: 'Automatic link sent for driver account creation linked to the company. The driver accepts the mission through the PWA.',
        },
        step4: {
          badge: 'Step 4',
          title: 'Loading & Departure',
          description: 'Driver checks in at the loading site. Validation via QR code or manual confirmation → status switches to "in transit".',
        },
        step5: {
          badge: 'Step 5',
          title: 'Delivery',
          description: 'Validation via QR code or "Delivered" button. Upload photos and POD/CMR documents. Notifications are sent instantly, status updated on dashboard.',
        },
        step6: {
          badge: 'Step 6',
          title: 'Payment & Closure',
          description: 'Admin validates delivered orders for daily payments. Invoice generated automatically. Shipper receives invoice and rates carrier.',
        },
      },
    },
    comparison: {
      title: "Find the solution that fits you",
      subtitle: "Whether you're a shipper or transporter, Velox simplifies managing your transport operations",
      shipper: {
        title: "Shippers",
        benefits: [
          "Post your freight orders in just a few clicks",
          "Access a network of verified transporters",
          "Track your deliveries in real-time",
          "Manage your invoices and payments easily",
          "Benefit from dedicated customer service"
        ],
        cta: "Start as a shipper"
      },
      transporter: {
        title: "Transporters",
        benefits: [
          "Access thousands of freight offers",
          "Optimize your fleet utilization",
          "Manage your drivers and vehicles simply",
          "Receive your payments quickly",
          "Grow your business efficiently"
        ],
        cta: "Start as a transporter"
      }
    },
    faq: {
      title: 'Frequently Asked Questions',
      subtitle: 'Everything you need to know about Velox',
      questions: {
        whatIsVelox: {
          question: 'What is Velox?',
          answer: 'Velox is a Progressive Web App designed to simplify transport mission management between shippers, carriers, and drivers. It centralizes freight publication, booking, assignment, delivery validation, and payment tracking.',
        },
        needDownload: {
          question: 'Do I need to download an app?',
          answer: 'No. Velox is a PWA — it works directly on desktop and mobile browsers. No App Store or Google Play installation required.',
        },
        whoCanUse: {
          question: 'Who can use Velox?',
          answer: 'Velox supports three main user types: Shippers (publish freight orders and track deliveries), Carriers (browse and book freight, assign missions to drivers), and Drivers (receive missions, validate steps, upload delivery documents).',
        },
        driverJoin: {
          question: 'How do drivers join the platform?',
          answer: 'Drivers receive an automatic link from their carrier. They create a connected driver account in just a few steps.',
        },
        deliveryValidation: {
          question: 'How is delivery validated?',
          answer: 'Delivery can be validated using a QR code scan or a manual confirmation button. Drivers can also upload POD/CMR documents and photos directly.',
        },
        notifications: {
          question: 'What kind of notifications are sent?',
          answer: 'Velox sends email notifications to shippers, carriers, and drivers for key events: bookings, mission assignments, status updates, and delivery confirmations.',
        },
        multilingual: {
          question: 'Is Velox multilingual and multi-currency?',
          answer: 'Yes. The PWA supports multiple languages and currencies so it can adapt to different markets.',
        },
        payment: {
          question: 'How does payment work?',
          answer: 'Once a delivery is marked complete, the Velox Admin validates it for daily payout. An invoice is generated automatically and sent to the shipper.',
        },
        history: {
          question: 'Can I see my past missions or shipments?',
          answer: 'Absolutely. Velox includes a full history for each role: Shipper (deliveries, costs, KPIs), Carrier (shipments, ratings, preferences), and Driver (missions + all related documents).',
        },
        production: {
          question: 'Is Velox a production app?',
          answer: 'This version is a prototype (V1) focused on core workflow and marketplace capabilities. More features will be added in the next iterations.',
        },
      },
    },
    ctaSection: {
      title: 'Ready to transform your logistics?',
      subtitle: 'Join the companies optimizing their transport with Velox',
      createAccount: 'Create a free account',
    },
    cta: {
      title: 'Ready to get started?',
      subtitle: 'Join us today',
    },
    footer: {
      copyright: '© 2025 Velox. All rights reserved.',
    },
  },

  // Not Found
  notFound: {
    message: 'Oops! Page not found',
    backToHome: 'Back to home',
  },

  // Create Order
  createOrder: {
    title: 'Create an order',
    subtitle: 'Fill in your transport information',
    
    section1: {
      title: '1. Route',
      description: 'Pickup and delivery information',
      pickup: 'Pickup',
      delivery: 'Delivery',
    },
    
    address: {
      streetNumber: 'Number',
      streetName: 'Street name',
      postalCode: 'Postal code',
      city: 'City',
      country: 'Country',
      streetNumberPlaceholder: '123',
      streetNamePlaceholder: 'Republic Street',
      postalCodePlaceholder: '75000',
      cityPlaceholder: 'Paris',
      countryPlaceholder: 'France',
    },
    
    dateTime: {
      pickupDate: 'Pickup date',
      pickupTime: 'Pickup time',
      deliveryDate: 'Delivery date',
      deliveryTime: 'Delivery time',
      chooseDate: 'Choose a date',
    },
    
    contact: {
      label: 'Contact',
      phone: 'Phone',
      contactPlaceholder: 'John Doe',
      phonePlaceholder: '6 12 34 56 78',
    },
    
    access: {
      detailsLabel: 'Access details (optional)',
      detailsPlaceholder: 'Ex: Gate code 1234, Entry via back parking, Ring at office 3...',
      detailsHelper: 'Specify details to access the pickup location',
      deliveryDetailsPlaceholder: 'Ex: 2nd floor doorbell, Street-side delivery, Visitor parking access...',
      deliveryDetailsHelper: 'Specify details to access the delivery location',
      photosLabel: 'Access photos (optional)',
      photosHelper: 'Maximum 5 images to help find the pickup location',
      deliveryPhotosHelper: 'Maximum 5 images to help find the delivery location',
      maxImagesError: 'Maximum 5 images allowed',
    },
    
    gps: {
      calculating: 'Calculating GPS position...',
      calculated: 'GPS position calculated',
    },
    
    section2: {
      title: '2. Cargo',
      subtitle: 'Cargo details to be transported',
      cargoTitle: 'Cargo title',
      cargoTitlePlaceholder: 'Ex: Pallets of electronics, Office furniture...',
      vehicleType: 'Vehicle type',
      vehicleTypePlaceholder: 'Select a type',
      anyVehicle: 'Any vehicle type',
      weight: 'Weight (kg)',
      weightPlaceholder: '1000',
      volume: 'Volume (m³)',
      volumePlaceholder: '10.5',
      unitType: 'Unit type',
      unitTypePlaceholder: 'Select a type',
      quantity: 'Quantity',
      quantityPlaceholder: 'Ex: 12',
      cargoDescription: 'Cargo description',
      cargoDescriptionPlaceholder: 'Describe the nature of your cargo...',
      specialInstructions: 'Special instructions',
      specialInstructionsPlaceholder: 'Specific requirements, time constraints...',
      cargoPhoto: 'Cargo photo (optional)',
      cargoPhotoHelper: 'An image to illustrate your cargo',
    },
    
    unitTypes: {
      palettes: 'Pallets',
      caisses: 'Boxes',
      euroPalettes: 'Euro-pallets',
    },
    
    section3: {
      title: '3. Pricing',
      subtitle: 'Price setting method',
      pricingMode: 'Pricing mode',
      fixedPrice: 'Fixed price',
      fixedPriceDesc: 'You set the transport price',
      auction: 'Auction',
      auctionDesc: 'Transporters submit their rates',
      proposedPrice: 'Proposed price (€)',
      proposedPricePlaceholder: '850.00',
    },
    
    section4: {
      title: '4. Visibility',
      subtitle: 'Order publication',
      marketplaceVisible: 'Make visible on marketplace',
      marketplaceVisibleDesc: 'Transporters will be able to see and submit bids',
    },
    
    actions: {
      saveDraft: 'Save draft',
      createOrder: 'Create order',
      creating: 'Creating...',
    },
    
    toasts: {
      draftSaved: 'Draft saved!',
      orderCreated: 'Order created and published!',
      priceRequired: 'Proposed price required to publish the order',
      error: 'Error creating the order',
    },
    
    validation: {
      numberTooLong: 'Number too long',
      streetNameRequired: 'Street name required (min. 3 characters)',
      streetNameTooLong: 'Street name too long',
      postalCodeRequired: 'Postal code required',
      postalCodeTooLong: 'Postal code too long',
      cityRequired: 'City required',
      cityTooLong: 'City too long',
      countryRequired: 'Country required',
      countryTooLong: 'Country too long',
      pickupDateRequired: 'Pickup date required',
      deliveryDateRequired: 'Delivery date required',
      invalidTime: 'Invalid time (format HH:MM)',
      contactRequired: 'Contact name required',
      contactTooLong: 'Name too long',
      phoneRequired: 'Phone required (min. 8 digits)',
      phoneTooLong: 'Phone too long',
      detailsTooLong: 'Details too long',
      cargoTitleRequired: 'Title required (min. 3 characters)',
      cargoTitleTooLong: 'Title too long',
      vehicleTypeRequired: 'Vehicle type required',
      weightRequired: 'Weight required',
      weightMax: 'Maximum weight 100,000 kg',
      volumeMax: 'Maximum volume 200 m³',
      quantityNegative: 'Quantity cannot be negative',
      quantityMax: 'Maximum 100',
      descriptionRequired: 'Description required (min. 10 characters)',
      descriptionTooLong: 'Description too long',
      instructionsTooLong: 'Instructions too long',
      priceRequired: 'Price required',
      priceMax: 'Maximum price €1,000,000',
    },
  },

  // Rating System
  rating: {
    title: 'Rate this delivery',
    question: 'How was this delivery?',
    comment: 'Comment (optional)',
    commentPlaceholder: 'Share your experience with this partner...',
    submit: 'Submit my rating',
    submitting: 'Submitting...',
    success: 'Thank you for your rating!',
    error: 'Error submitting rating',
    alreadyRated: 'You have already rated this order',
    rateDelivery: 'Rate delivery',
    rateClient: 'Rate this client',
    toRate: 'To rate',
    noRatingsYet: 'No ratings yet',
    
    excellent: 'Excellent! 🌟',
    veryGood: 'Very good 👍',
    good: 'Good ✓',
    fair: 'Fair',
    poor: 'Poor',
    
    companyProfile: {
      title: 'Ratings',
      average: 'Average rating',
      totalReviews: 'reviews',
      distribution: 'Rating distribution',
    },
    
    yourRating: 'Your rating',
    partnerRating: 'Partner rating',
  },

  // Toast
  toast: {
    reservationConfirmed: 'Reservation confirmed successfully',
    reservationDeclined: 'Reservation declined',
    error: 'An error occurred',
  },

  // Legal
  legal: {
    termsOfService: {
      title: "Terms and Conditions",
      lastUpdate: "Last updated",
      section1: {
        title: "1. Purpose",
        content: "These Terms and Conditions define the terms of use of the Velox platform, a service connecting shippers and carriers. By using our platform, you unconditionally accept these Terms and Conditions.",
      },
      section2: {
        title: "2. Registration and User Account",
        content: "Using the platform requires creating a user account. You agree to provide accurate and up-to-date information, including your Tax ID/VAT number and bank details (IBAN). You are responsible for the confidentiality of your login credentials.",
      },
      section3: {
        title: "3. Services Provided",
        content: "Velox connects shippers needing transport services with professional carriers. The platform facilitates order creation, bid submission, real-time tracking, and billing management. Velox acts solely as an intermediary and is not party to the transport contract.",
      },
      section4: {
        title: "4. User Obligations",
        content: "Shippers agree to provide accurate information about their goods. Carriers agree to have the necessary licenses and insurance to operate. All users agree to comply with applicable legislation and not to use the platform for fraudulent purposes.",
      },
      section5: {
        title: "5. Pricing and Payment",
        content: "Prices are freely negotiated between shippers and carriers. Velox charges a commission on each transaction made through the platform. Payments are secure and processed through our integrated payment system. Invoices are available in the billing section.",
      },
      section6: {
        title: "6. Responsibilities",
        content: "Velox cannot be held liable for damages resulting from the execution of the transport contract between shipper and carrier. Velox's liability is limited to providing the platform. In case of dispute, parties agree to seek an amicable solution before any legal action.",
      },
    },
    privacyPolicy: {
      title: "Privacy Policy",
      lastUpdate: "Last updated",
      section1: {
        title: "1. Platform Publisher",
        content: "Velox is published by [Company Name], a simplified joint-stock company with capital of [amount] euros, registered with the RCS of [city] under number [number], with registered office at [full address]. Publishing Director: [Name]. Contact: contact@velox.com",
      },
      section2: {
        title: "2. Hosting",
        content: "The Velox platform is hosted by Supabase Inc., 970 Toa Payoh North, #07-04, Singapore 318992. The service uses secure cloud infrastructure with servers located in Europe (GDPR compliant).",
      },
      section3: {
        title: "3. Personal Data Protection",
        content: "In accordance with GDPR, you have the right to access, rectify, and delete your personal data. The data collected (name, email, phone, Tax ID, IBAN) is necessary for the service operation and is securely stored. It is never shared with third parties without your consent.",
      },
      section4: {
        title: "4. Cookies",
        content: "The platform uses technical cookies essential to the service operation (authentication, language preferences). No advertising or tracking cookies are used. You can configure your browser to refuse cookies, but this may affect certain features.",
      },
      section5: {
        title: "5. Intellectual Property",
        content: "All elements of the Velox platform (logos, texts, graphics, software) are protected by copyright and are the exclusive property of Velox. Any unauthorized reproduction, representation, or exploitation is prohibited.",
      },
      section6: {
        title: "6. Applicable Law",
        content: "These legal notices are governed by French law. In case of dispute, French courts will have sole jurisdiction. For any questions regarding legal notices, you can contact us at: legal@velox.com",
      },
    },
  },
  support: {
    title: 'Velox Support',
    description: 'Contact our support team',
    callVelox: 'Call Velox',
    email: 'Email',
    phone: 'Phone',
    adminTitle: 'Velox support contacts',
    adminDescription: 'These details are shown to users when they contact support.',
  },
  supportChat: {
    title: 'Velox Support',
    adminTitle: 'Support tickets',
    adminNav: 'Support',
    open: 'Open chat',
    yourTickets: 'Your tickets',
    newTicket: 'New ticket',
    empty: 'No tickets yet',
    writeMessage: 'Write a message…',
    send: 'Send',
    skip: 'Skip this step',
    pickOrder: 'Select the related order:',
    descPlaceholder: 'Describe your issue or request…',
    selectTicket: 'Select a ticket to view the conversation',
    markResolved: 'Mark resolved',
    close: 'Close',
    assignMe: 'Assign to me',
    filter: { all: 'All statuses' },
    status: {
      bot: 'Qualifying',
      pending_admin: 'Pending',
      open: 'Open',
      resolved: 'Resolved',
      closed: 'Closed',
    },
    cat: {
      offer: 'An offer',
      mission: 'A mission',
      account: 'My account',
      payment: 'Payment / billing',
      other: 'Other',
    },
    bot: {
      greeting: 'Hi 👋 I\'m the Velox assistant. I will direct you to the right person.',
      askCategory: 'What would you like to contact us about?',
      askContext: 'Which order is your request about? (you can also skip this step)',
      askDescription: 'Describe your request in a few words and our team will reply shortly.',
      handoff: 'Thanks! A Velox team member will take over and reply as soon as possible.',
    },
  },
  adminCreate: {
    navShort: 'Create account',
    title: 'Create an account',
    subtitle: 'Create a shipper company, transporter company, or add a driver to an existing company.',
    tabs: {
      shipper: 'Shipper company',
      transporter: 'Transporter company',
      driver: 'Driver',
      admin: 'Administrator',
    },
    sections: {
      company: 'Company information',
      ownerInfo: 'Account owner',
      driverInfo: 'Driver information',
      adminInfo: 'Administrator information',
      attachToTransporter: 'Transporter company',
      activation: 'Account activation',
    },
    fields: {
      foundedDate: 'Company founding date',
      companyName: 'Company name',
      companyPhone: 'Company phone',
      transporter: 'Transporter company',
      transporterPlaceholder: 'Select a company',
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
      phone: 'Phone',
      password: 'Temporary password',
      passwordPlaceholder: 'At least 8 characters',
      passwordHint: 'The user can change it after signing in.',
    },
    mode: {
      invite: {
        label: 'Send an email invitation',
        desc: 'The user receives a link to set their password and activate the account.',
      },
      direct: {
        label: 'Create directly with a password',
        desc: 'The account is immediately active. Share the password with the user.',
      },
    },
    submit: {
      invite: 'Send invitation',
      direct: 'Create account',
    },
    success: {
      invite: 'Invitation sent successfully.',
      direct: 'Account created successfully.',
    },
    errors: {
      missingUser: 'Fill in all user fields.',
      missingCompany: 'Fill in the company name and phone.',
      pickCompany: 'Select a transporter company.',
      shortPassword: 'Password must be at least 8 characters.',
      emailTaken: 'This email address already belongs to an existing account. No account or email was created.',
      generic: 'Error while creating the account.',
    },
  },
  emailTemplates: {
    tab: 'Emails',
    title: 'Email templates',
    description: 'Customize emails sent when creating accounts.',
    invitation: 'Invitation (user activation)',
    passwordReset: 'Password reset',
    signupWelcome: "Welcome (sign-up)",
    emailChange: "Email address change",
    directWelcome: 'Welcome (direct creation)',
    subject: 'Subject',
    bodyHtml: 'HTML body',
    enabled: 'Email enabled',
    enabledHint: 'If disabled, no email will be sent.',
    bccAdmin: 'BCC the admin',
    bccAdminHint: 'Receive a hidden copy of every email sent.',
    variables: 'Available variables',
  },
  adminDocuments: {
    docSearchPlaceholder: 'Search a document (file, category, order, plate, driver)...',
    categoryAll: 'All categories',
    statusAll: 'All statuses',
    resetFilters: 'Reset',
    noResults: 'No document matches your search.',
    companiesShown_one: '{{count}} company displayed',
    companiesShown_other: '{{count}} companies displayed',
    addedByVelox: 'Added by Velox',
    categories: {
      kyc: 'KYC / identity',
      insurance_license: 'Insurance & licence',
      contract: 'Contract / commercial',
      registration_card: 'Registration document',
      inspection: 'Technical inspection',
      driver_license: 'Driving licence',
      loading_photos: 'Loading photos',
      delivery_photos: 'Delivery photos',
      cmr: 'CMR / delivery note',
      other: 'Other',
    },
    add: {
      button: 'Add a document',
      buttonShort: 'Add',
      title: 'Add a document',
      description: 'This document will be attached to {{company}} and visible to that company.',
      scope: 'Attach to',
      scopeCompany: 'Company (onboarding)',
      scopeOrder: 'An order (freight)',
        scopeVehicle: 'A vehicle',
        scopeDriver: 'A driver',
        vehicle: 'Vehicle',
        vehicleSearch: 'Search for a vehicle...',
        vehiclePlaceholder: 'Select a vehicle',
        noVehicles: 'This company has no vehicle registered yet.',
        noDrivers: 'This company has no driver registered yet.',
        vehicleRequired: 'Please select a vehicle.',
        driver: 'Driver',
        driverSearch: 'Search for a driver...',
        driverPlaceholder: 'Select a driver',
        driverRequired: 'Please select a driver.',
      order: 'Order',
      orderSearch: 'Search an order...',
      orderPlaceholder: 'Select an order',
      category: 'Category',
      label: 'Label',
      labelPlaceholder: 'E.g. Insurance certificate 2026',
      expiry: 'Expiry date (optional)',
      notes: 'Internal note (optional)',
      chooseFile: 'Choose a file',
      fileHint: 'Accepted formats: PDF, JPG, PNG (max 10 MB)',
      uploading: 'Uploading...',
      submit: 'Add the document',
      success: 'Document added',
      error: 'The document could not be added',
      invalidType: 'Unsupported format. Use PDF, JPG or PNG.',
      tooLarge: 'File too large (max 10 MB)',
      fileRequired: 'Please select a file',
      orderRequired: 'Please select an order',
      deleteTitle: 'Delete this document?',
      deleteDescription: '{{name}} will be permanently deleted. This action cannot be undone.',
      deleteSuccess: 'Document deleted',
      deleteError: 'The document could not be deleted',
    },
    breadcrumb: 'Documents',
    shippers: 'Shippers',
    transporters: 'Transporters',
    title: 'User documents',
    subtitle: 'Select a company to view its documents organized by category.',
    searchPlaceholder: 'Search a company...',
    noCompanies: 'No {{side}} company.',
    sideShipper: 'shipper',
    sideTransporter: 'transporter',
    usersCount_one: '{{count}} user',
    usersCount_other: '{{count}} users',
    docsCount_one: '{{count}} doc',
    docsCount_other: '{{count}} docs',
    expiredCount_one: '{{count}} expired',
    expiredCount_other: '{{count}} expired',
    missingCount_one: '{{count}} missing',
    missingCount_other: '{{count}} missing',
    complete: 'Complete',
    back: 'Back',
    sectionOnboarding: 'Onboarding',
    sectionFleet: 'Fleet',
    sectionFreight: 'Freight',
    onboardingTitle: 'Onboarding documents',
    onboardingDesc: 'KBIS, VAT, IBAN, transport license, liability insurance, terms…',
    onboardingEmpty: 'No onboarding documents uploaded for this company.',
    fleetTitle: 'Fleet documents',
    trucks: 'Trucks',
    trailers: 'Trailers',
    drivers: 'Drivers',
    emptyTrucks: 'No truck registered.',
    emptyTrailers: 'No trailer registered. (Truck/trailer distinction coming soon.)',
    emptyDrivers: 'No driver registered.',
    noDocsResource: 'No document attached.',
    freightTitle: 'Freight documents',
    freightDesc: 'One entry per order: transport order, CMR / POD, customs, disputes, photos.',
    freightEmpty: 'No order with documents.',
    orderLabel: 'Order {{number}}',
    noDocs: 'No document.',
    tableNature: 'Type',
    tableFile: 'File',
    tableStatus: 'Status',
    tableSize: 'Size',
    tableDate: 'Date',
    tableAction: 'Action',
    statusVerified: 'Verified',
    statusExpiring: 'Expiring soon',
    statusExpired: 'Expired',
    statusUnverified: 'Unverified',
    licensePrefix: 'License',
    licenseExpires: 'expires',
    licenseNotSet: 'License not set',
    openError: 'Unable to open document',
    natureRegistration: 'Registration card',
    natureInsurance: 'Insurance',
    natureInspection: 'Technical inspection',
    natureOther: 'Other',
    natureCargo: 'Cargo photo',
    natureStart: 'Pickup photo',
    natureDelivery: 'Delivery photo',
    natureDocument: 'Document',
  },
  footer: {
    tagline: 'The transport and freight platform connecting shippers, carriers and drivers across Europe.',
    legalTitle: 'Legal information',
    contactTitle: 'Support',
    partnersTitle: 'Our partners',
    copyright: '© 2026 Velox. All rights reserved.',
    links: {
      about: 'About us',
      terms: 'Terms of service',
      privacy: 'Privacy policy',
      legalNotice: 'Legal notice',
      cookiePolicy: 'Cookie policy',
      cookieSettings: 'Cookie settings',
    },
    short: {
      about: 'About',
      terms: 'Terms',
      privacy: 'Privacy',
      legalNotice: 'Legal notice',
      cookies: 'Cookies',
      support: 'Support',
    },
  },
  legalNotice: {
    back: 'Back to home',
    title: 'Legal notice',
    lastUpdated: 'Last updated: January 2026',
    sections: {
      publisher: {
        title: 'Site publisher',
        body: 'Velox\nTransport and freight management platform.\nContact: support@myvelox.eu\nWebsite: https://myvelox.eu',
      },
      hosting: {
        title: 'Hosting',
        body: 'The website and its services are hosted by cloud infrastructure providers located in the European Union.',
      },
      intellectualProperty: {
        title: 'Intellectual property',
        body: 'All content on the platform (texts, visuals, logos, code) is protected by intellectual property law. Any reproduction or reuse without prior written authorisation is prohibited.',
      },
      dataProtection: {
        title: 'Data protection',
        body: 'Personal data is processed in accordance with the GDPR. For more information, see our privacy policy. You may exercise your rights of access, rectification and deletion by contacting our support team.',
      },
      contact: {
        title: 'Contact',
        body: 'For any question regarding this legal notice, contact our support team from within the app or by email.',
      },
    },
  },
  cookies: {
    alwaysOn: 'Always on',
    banner: {
      title: 'We respect your privacy',
      description: 'We use cookies that are strictly necessary to run Velox and, with your consent, functional and analytics cookies.',
      readPolicy: 'Read the cookie policy',
      customize: 'Customise',
      acceptAll: 'Accept all',
      rejectAll: 'Reject all',
      save: 'Save my choices',
    },
    categories: {
      necessary: {
        title: 'Strictly necessary cookies',
        description: 'Essential for the site to work (session, security, remembering your cookie choices).',
      },
      functional: {
        title: 'Functional cookies',
        description: 'Remember your preferences, such as your selected language.',
      },
      analytics: {
        title: 'Analytics cookies',
        description: 'Help us understand how the site is used (PostHog) so we can improve it.',
      },
    },
  },
  invite: {
    title: 'Join Velox',
    subtitle: 'You have been invited to join',
    subtitleRole: 'as',
    email: 'Email',
    firstName: 'First name',
    lastName: 'Last name',
    password: 'Password',
    passwordPlaceholder: 'At least 8 characters',
    confirmPassword: 'Confirm password',
    confirmPasswordPlaceholder: 'Retype your password',
    creating: 'Creating...',
    createAccount: 'Create my account',
    invalidTitle: 'Invalid invitation',
    invalidDescription: 'This invitation is invalid, expired or already used. Please contact the person who invited you.',
    backToLogin: 'Back to login',
    welcome: 'Welcome!',
    accountConfigured: 'Your account has been set up.',
    accountReady: 'Account ready',
    pleaseSignIn: 'Sign in with your new password.',
    sentInvitations: 'Sent invitations',
    statusAccepted: 'Accepted',
    passwordSet: 'Password created',
    emailAlreadyUsed: 'This address already belongs to an account ({{company}} — {{role}}). No email was sent.',
    invitationAlreadyPending: 'An invitation is already pending for this address ({{company}}). No email was sent.',
    errors: {
      expired: 'This invitation has expired.',
      alreadyAccepted: 'This invitation has already been used.',
      invalidToken: 'Invalid invitation link.',
      weakPassword: 'Password must be at least 8 characters.',
      passwordMismatch: 'Passwords do not match.',
      generic: 'We could not complete your registration. Please retry or contact support.',
    },
  },
  adminInvitations: {
    actions: 'Actions',
    resend: 'Resend invitation',
    resendSuccess: 'Invitation resent',
    resendSuccessDescription: 'A new email was sent to {{email}}.',
    resendError: 'The invitation could not be resent.',
    delete: 'Delete',
    deleteTitle: 'Delete this invitation?',
    deleteDescription: 'The invitation link will stop working immediately. This action cannot be undone.',
    deleteSuccess: 'Invitation deleted',
    deleteError: 'The invitation could not be deleted.',
    searchPlaceholder: 'Search an invitation...',
    refresh: 'Refresh',
    pageInfo: 'Page {{page}} / {{total}} — {{count}} invitation(s)',
    title: 'Sent invitations',
    empty: 'No invitation yet.',
    person: 'Person',
    email: 'Email',
    company: 'Company',
    role: 'Role',
    sentAt: 'Sent on',
    expiresAt: 'Expires on',
    status: 'Status',
    statuses: {
      pending: 'Pending',
      accepted: 'Accepted',
      expired: 'Expired',
    },
  },
};
